import { useEffect, useState } from "react";
import { api } from "@utils/index";
import { LoadingOverlay } from "@/apps/@components/loading-overlay";

const parseContent = (content) =>
	typeof content === "string" ? JSON.parse(content) : content;

// Renderer map — add new types here without changing render logic
const MESSAGE_RENDERERS = {
	text: ({ content }) => <p style={styles.message}>{content}</p>,
	image: ({ content }) => {
		const data = parseContent(content);
		return <img src={data.originalContentUrl} alt="" style={styles.image} />;
	},
	flex: ({ content }) => {
		// Flex messages are LINE-only; render alt text in LIFF context
		const data = parseContent(content);
		return <p style={styles.message}>{data.altText ?? ""}</p>;
	},
	cta: ({ content }) => {
		const data = parseContent(content);
		return (
			<button
				style={styles.button}
				onClick={() => { window.location.href = data.url; }}
			>
				{data.label}
			</button>
		);
	},
};

function MessageBlock({ type, content }) {
	const renderer = MESSAGE_RENDERERS[type];
	if (!renderer) return null;
	return renderer({ content });
}

export default function CampaignCouponPage() {
	const [loading, setLoading] = useState(true);
	const [messages, setMessages] = useState([]);

	useEffect(() => {
		const controller = new AbortController();

		(async () => {
			try {
				const campaignCode = new URLSearchParams(window.location.search).get("campaign_code");

				if (!campaignCode) {
					console.error("CampaignCouponPage missing campaign_code in URL");
					setLoading(false);
					return;
				}

				const res = await api.post("/campaign/coupon/claim", { campaign_code: campaignCode }, { signal: controller.signal });
				setMessages(res.messages ?? []);
			} catch (e) {
				if (e?.name !== "CanceledError") {
					console.error("CampaignCouponPage claim failed:", e);
				}
			} finally {
				if (!controller.signal.aborted) {
					setLoading(false);
				}
			}
		})();

		return () => controller.abort();
	}, []);

	if (loading) {
		return <LoadingOverlay visible={true} />;
	}

	if (messages.length === 0) {
		return (
			<div style={styles.container}>
				<p style={styles.message}>領取完成！</p>
			</div>
		);
	}

	return (
		<div style={styles.container}>
			{messages.map((msg, i) => (
				<MessageBlock key={i} type={msg.type} content={msg.content} />
			))}
		</div>
	);
}

const styles = {
	container: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		minHeight: "60svh",
		padding: "32px 24px",
		textAlign: "center",
		backgroundColor: "#fff",
		boxSizing: "border-box",
	},
	message: {
		fontSize: "16px",
		lineHeight: "1.6",
		color: "#222",
		marginBottom: "24px",
		whiteSpace: "pre-wrap",
	},
	image: {
		maxWidth: "100%",
		marginBottom: "24px",
	},
	button: {
		backgroundColor: "#000",
		color: "#fff",
		border: "none",
		borderRadius: "4px",
		padding: "14px 40px",
		fontSize: "15px",
		cursor: "pointer",
		letterSpacing: "0.05em",
		marginTop: "8px",
	},
};
